import { MainBreadcrumbItem } from '../../MainBreadcrumb/MainBreadcrumb';
import React, { useContext, useEffect, useState } from 'react';
import { SelectedMenuContext } from '../../../contexts/selectedMenu.context';
import { useWindowDimensions } from '../../../hooks/useWindowDimensions';
import { ForkliftInterface } from '../../../types/forklift.interface';
import { fetcher } from '../../../extras/fetcher';
import { ColumnsType } from 'antd/es/table';
import { myStringSorter } from '../../../extras/sorters';

import { PermError } from '../NotFoundPage/PermError';
import { DeleteForklift } from './DeleteForklift';
import { TableHeader } from '../Ikea/Stan/TableHeader';
import { Button, message, Table } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { AddForkliftType, ModalAddForklift } from './ModalAddForklift';
import { Link } from 'react-router-dom';

interface Props {
  handleSetMainTitle: (title: string) => void;
  setBreadcrumbHandler: (items: MainBreadcrumbItem[] | null) => void;
}

export const Forklift = (props: Props) => {

  const [loading, setLoading] = useState<boolean>(false);
  const selectedMenuContext = useContext(SelectedMenuContext);
  const { windowHeight } = useWindowDimensions();
  const [permError, setPermError] = useState<boolean>(false);
  const [tableData, setTableData] = useState<ForkliftInterface[]>([]);
  const [forklift, setForklift] = useState<AddForkliftType>({
    id: '',
    number: '',
    comment: '',
    mark: '',
    model: '',
    serialNumber: '',
  });

  const [modalAddForkliftOpened, setModalAddForkliftOpened] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();



  const getData = async () => {

    setLoading(true);

    const data = await fetcher(`forklift`);
    if(data.status === 403) {
      setPermError(true);
      return;


    }

    const result: ForkliftInterface[] = data.result;

    setTableData(result);
    setLoading(false);


  }

  useEffect(() => {
    getData();
  },[]);


  useEffect(() => {
    const breadcrumbItems: MainBreadcrumbItem[]=[
      {
        href: '',
        key: 'forklift',
        label: 'Przegląd Wózków',
      },
      {
        href: '/forklift',
        key: 'forklift_forklift',
        label: 'Wózki Widłowe',
      },
    ];


    props.handleSetMainTitle('Wózki Widłowe');
    props.setBreadcrumbHandler(breadcrumbItems);

    selectedMenuContext?.setSelectedKey(['forklift_forklift']);

  },[]);


  const columns: ColumnsType<ForkliftInterface> = [
    {
      title: 'Numer Wózka',
      minWidth: 100,
      dataIndex: 'number',
      sorter: (a, b) => myStringSorter(a.number, b.number),
      sortDirections: ['descend', 'ascend'],
      render: (value, record) => <Link to={`inspections/${record.id}`}>{value}</Link>
    },
    {
      title: 'Numer seryjny',
      minWidth: 200,
      dataIndex: 'serialNumber',
      sorter: (a, b) => myStringSorter(a.serialNumber, b.serialNumber),
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: 'Marka',
      minWidth: 100,
      dataIndex: 'mark',
      sorter: (a, b) => myStringSorter(a.mark, b.mark),
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: 'Model',
      minWidth: 100,
      dataIndex: 'model',
      sorter: (a, b) => myStringSorter(a.model, b.model),
      sortDirections: ['descend', 'ascend'],
    },


    {
      title: 'Komentarz',
      minWidth: 150,
      dataIndex: 'comment',
      sorter: (a, b) => myStringSorter(a.comment, b.comment),
      sortDirections: ['descend', 'ascend'],
      render: (value, record) => {
        const comment = record.comment;
        const wrappedComment = comment && comment.length > 45
          ? comment.match(/.{1,45}/g)?.map((part, index) => <div key={index}>{part}</div>)
          : comment;
        return <div>{wrappedComment}</div>;
      },
    },



    {
      minWidth: 30,
      title: '',
      align: 'center',
      filterMode: 'tree',
      render: (value, record) =>  <><Button icon={<EditOutlined />} onClick={() => handleEditForkliftButton(record)}/><DeleteForklift messageApi={messageApi} id={record.id} number={record.number} getData={getData} /></>

    },


  ];



  const handleEditForkliftButton = (selectedForklift: ForkliftInterface) => {
    setForklift(selectedForklift);
    setModalAddForkliftOpened(true);
  }


  const updateForklift = (updForklift: ForkliftInterface) => {
    setTableData((prev) => {

      if(prev.findIndex((x) => x.id === updForklift.id) === -1) {
        const data = prev;

        data.push(updForklift);
        return data;
      } else {

        const data = prev.map((x) => {
          if(x.id === updForklift.id) {
            return {
              x,
              ...updForklift,
            }
          } else {
            return x
          }
        })

        return data;

      }

    })
  }


  const handleAddForkliftButton = () => {
    setForklift({
      id: '',
      serialNumber: '',
      number: '',
      model: '',
      comment: '',
      mark: '',
    });

    setModalAddForkliftOpened(true)

  }


  if(permError) {
    return <PermError/>
  }


  return (
  <>
    <Table
      rowKey={'id'}
      title={(records) => <TableHeader getData={getData} selectedCount={0} additional={<><Button icon={<PlusOutlined />} onClick={handleAddForkliftButton}>Dodaj Wózek</Button></>}/> } columns={columns} scroll={{ y: windowHeight *.6}} pagination={false} loading={loading} showHeader={true} bordered={true} dataSource={tableData} style={{opacity: 0.9}} size={'small'} />


    <ModalAddForklift forklift={forklift} handleSetData={updateForklift} handleSetModalOpened={setModalAddForkliftOpened} open={modalAddForkliftOpened} />
    {contextHolder}
  </>

  )



}
